import { TimelineLite } from 'gsap/TweenMax';

import { qs, isMobile } from '@/scripts/utils';

import { eventIn, eventOut } from '@/scripts/timelines/eventPageTransitions';
import { buttonIn, buttonOut } from '@/scripts/timelines/buttonsTransitions';
import { museletOut } from '@/scripts/timelines/museletTransitions';
import { uiIn } from '@/scripts/timelines/uiTransitions';
import { numberIn, numberOut } from '@/scripts/timelines/numberTransitions';

const eventTransition = (el, dir, prevPage, nextPage, callback) => {
  const tl = new TimelineLite();

  const eventInTl = () => {
    const animEventIn = eventIn(el);

    animEventIn.play();

    if (prevPage === 'event') {
      animEventIn.eventCallback('onComplete', () => {
        callback();
      });
    }
  };

  const eventOutTl = () => {
    const animEventOut = eventOut(el);
    animEventOut.play().timeScale(1.5).eventCallback('onComplete', () => {
      callback();
    });
  };

  const ButtonInTl = () => {
    const animButtonIn = buttonIn(el);
    animButtonIn.play();
    if (prevPage === 'index' || prevPage === 'loader') {
      animButtonIn.eventCallback('onComplete', () => {
        qs('.event__btns').classList.remove('avoid');
        callback();
      });
    }
  };

  const buttonOutTl = () => {
    buttonOut(el).play().timeScale(2);
  };

  const museletOutTl = () => {
    museletOut(document);
  };

  const numberInTl = () => {
    numberIn(qs('.number', el)).play();
  };

  const numberOutTl = () => {
    numberOut(qs('.number', el)).play();
  };


  const uiTl = () => {
    uiIn(qs('header')).play();
    if (!isMobile()) {
      uiIn(qs('footer')).play();
    }
  };

  if (dir === 'in') {
    if (prevPage === 'loader') {
      tl
        .add(museletOutTl, 0)
        .add(uiTl, 2)
        .add(eventInTl, 1)
        .add(numberInTl, 1)
        .add(ButtonInTl, 1);
    }
    if (prevPage === 'event') {
      tl
        .add(numberInTl)
        .add(eventInTl)
        .eventCallback('onComplete', () => qs('.event__btns').classList.remove('avoid'));
    }
    if (prevPage === 'index') {
      tl
        .add(museletOutTl, 0)
        .add(numberInTl, 1)
        .add(eventInTl, 1)
        .add(ButtonInTl, 1);
    }
  } else if (dir === 'out') {
    if (nextPage === 'event') {
      tl
        .add(numberOutTl)
        .add(eventOutTl);
    } else {
      tl
        .add(numberOutTl)
        .add(buttonOutTl)
        .add(eventOutTl);
    }
  }

  return tl;
};

export default eventTransition;



// WEBPACK FOOTER //
// ./src/scripts/timelines/eventTransition.js